export default "__VITE_ASSET__OzW1lJaZ__"